import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import btnStyles from "../../UIs/PrimaryHero.module.css";
import LandingHeroImages from "../../UIs/LandingHeroImages";

const Wrapper = styled.div`
  background-color: var(--bgColorFrontend);
  color: var(--white);
  padding-bottom: 40px;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-top: 86px;
`;

const HeroContent = styled.div`
  text-align: center;
  max-width: 900px;
  margin: 50px auto 40px auto;
  padding: 0 20px;

  @media (max-width: 576px) {
    margin: 35px auto;
  }
`;

const SubText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: var(--white);
  max-width: 650px;
  margin: 0 auto 24px auto;

  span {
    font-weight: 500;
    color: var(--brandColorFrontend);
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;
`;

const Heading = styled.h1`
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 1.5rem;

  @media (max-width: 992px) {
    font-size: 2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.5rem;
  }
`;

const HeroSection = () => {
  return (
    <Wrapper>
      <HeroContent>
        <Heading>
          Stop Overpaying for Multiple <br />
          Freelance Tools
        </Heading>
        <SubText>
          The all-in-one workspace for <span>invoices, contracts, and projects</span>. Built
          for freelancers, VAs, and teams to manage everything in one place.
        </SubText>
        <h3
          style={{ marginTop: "0px", marginBottom: "25px", fontWeight: "500" }}
        >
          Starting at $2.99/month
        </h3>

        <StyledLink to="/db/signup" className={btnStyles.btn_begin}>
          Get Started for Free
        </StyledLink>
      </HeroContent>

      <LandingHeroImages />
    </Wrapper>
  );
};

export default HeroSection;
